import bct1 from './bcts/1';
import bct2 from './bcts/2';
import bct4 from './bcts/4';
import bct9 from './bcts/9';
import bct12 from './bcts/12';
import bct18 from './bcts/18';
import bct23 from './bcts/23';
import bct32 from './bcts/32';
import bct56 from './bcts/56';
import bct57 from './bcts/57';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  bct1,
  bct2,
  bct4,
  bct9,
  bct12,
  bct18,
  bct23,
  bct32,
  bct56,
  bct57,
};